const SET_IS_ADD_VISIBLE = '@@promoAdd/SET_IS_ADD_VISIBLE';
const SET_DEFAULT_PROMO = '@@promoAdd/SET_DEFAULT_PROMO';
const SET_EDITING_MODE = '@@SET_EDITING_MODE';

export default {
  SET_IS_ADD_VISIBLE,
  SET_DEFAULT_PROMO,
  SET_EDITING_MODE
};
